import { Avatar, Chip, Theme, makeStyles } from '@forgeglobal/design-framework'
import { OwnerFragment } from 'graphql/bindings/AdminBindings'
import React from 'react'

const getOwnerLetters = (owner: OwnerFragment) => {
  const firstLetter = owner.first_name.length ? owner.first_name[0] : ''
  const secondLetter = owner.last_name.length ? owner.last_name[0] : ''
  return firstLetter + secondLetter
}

const useStyles = makeStyles((theme: Theme) => ({
  img: {
    height: '50%',
    width: '50%',
    borderRadius: '100px',
  },
  label: {
    paddingLeft: 0,
  },
}))

const OwnerAvatar: React.FC<{ owner: OwnerFragment }> = ({ owner }) => {
  const classes = useStyles()
  if (owner.user.profile_picture) {
    return <Avatar src={owner.user.profile_picture} classes={{ img: classes.img }} />
  }
  return <Avatar classes={{ img: classes.img }}>{getOwnerLetters(owner)}</Avatar>
}

const OwnerChip: React.FC<{ owner?: OwnerFragment }> = ({ owner }) => {
  const classes = useStyles()
  if (!owner) {
    return null
  }
  return <Chip avatar={<OwnerAvatar owner={owner} />} classes={{ label: classes.label }} label={owner.name} />
}

export { OwnerChip }
